const excepts = ["index", "base"];
const modulesFiles = require.context('./', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    if (!excepts.includes(moduleName)) {
        modules[moduleName] = modulesFiles(modulePath)
    }
    return modules
}, {})
export default modules